import React from "react";
import { Badge, Card } from "react-bootstrap";
import { whatsNewItems } from "@/data/whatsNew";
import "./WhatsNewPage.scss";

const WhatsNewPage: React.FC = () => {
  const totalItems = whatsNewItems.length;

  return (
    <div className="whats-new-page">
      <div className="mb-3">
        <h2 className="mb-1">What&apos;s New</h2>
        <p className="text-muted mb-0">
          Release notes and platform updates. Showing all {totalItems} entries.
        </p>
      </div>

      <div className="whats-new-list">
        {whatsNewItems.map((item) => (
          <Card key={item.id} className="whats-new-card mb-3">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                <div className="d-flex align-items-center gap-2">
                  <h5 className="mb-0">{item.title}</h5>
                  <Badge bg="secondary">{item.area}</Badge>
                </div>
                <small className="text-muted">{item.date}</small>
              </div>

              <p className="mb-2">{item.summary}</p>

              <ul className="mb-0">
                {item.details.map((detail, idx) => (
                  <li key={`${item.id}-${idx}`}>{detail}</li>
                ))}
              </ul>
            </Card.Body>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default WhatsNewPage;
